import axios from 'axios';

export const create = (requestParams, formData, callback) => {
  let promise = axios({
    method: 'post',
    url: Routes.abstract_documents_path({ ... {... requestParams }, format: 'json', _options: true }),
    data: formData,
    headers: {
      "X-CSRF-TOKEN": window.compliance.token,
    }
  });

  promise
    .then(response => {
      callback(response);
    })
    .catch(error => {
      callback(error.response);
    });
}

export const update = (requestParams, formData, callback) => {
  var promise = axios({
    method: 'PATCH',
    url: Routes.abstract_document_path({ ... { ... requestParams }, format: "json", _options: true }),
    data: formData,
    headers: {
      "X-CSRF-TOKEN": window.compliance.token,
    },
  });

  promise
    .then(response => {
      callback(response);
    })
    .catch(error => {
      callback(error.response);
    });
};

export const index = (requestParams , callback) => {
  var promise = axios({
    method: 'get',
    url: Routes.abstract_documents_path({ ...{...requestParams}, format: "json", _options: true}),
    headers: {
      "X-CSRF-TOKEN": window.compliance.token,
    },
  });

  promise
    .then(response => {
      callback(response);
    })
    .catch(error => {
      callback(error.response);
    });
};

export const getByIds = (requestParams, formData, callback) => {
  var promise = axios({
    method: 'post',
    url: Routes.get_by_ids_abstract_documents_path({...{...requestParams}, format: "json" }),
    data: formData,
    headers: {
      "X-CSRF-TOKEN": window.compliance.token,
    },
  });

  promise
    .then(response => {
      callback(response);
    })
    .catch(error => {
      callback(error.response);
    });
};